import { match } from '@/utils/pattern-match-util'

export type AvailableBookkeepingSoftwareType =
  (typeof availableBookkeepingSoftwareTypes)[number]

export const availableBookkeepingSoftwareTypes = [
  'Freshbooks',
  'Puzzle',
  'Sage',
  'Wave',
  'XeroTaxfyleOffering',
  'QuickBooksDesktop',
  'Other',
] as const

export function formatAvailableBookkeepingSoftware(
  type: AvailableBookkeepingSoftwareType,
) {
  return match(type, {
    Freshbooks: 'Freshbooks',
    Puzzle: 'Puzzle',
    Sage: 'Sage',
    Wave: 'Wave',
    XeroTaxfyleOffering: 'Xero - Taxfyle Offering',
    QuickBooksDesktop: 'QuickBooks Desktop',
    Other: 'Other',
  })
}
